"use client";
import React from "react";
import Link from "next/link";
import Image from "next/image";
import { Button } from "@/components/ui/button";
import { Star, Trash2 } from "lucide-react";
import { useBookmarksContext } from "@/context/BookmarksProvider";
import { urlFor } from "@/sanity/lib/image";

const Bookmarks = () => {
  const { bookmarks, removeItem, clearFilter } = useBookmarksContext();

  if (bookmarks.length === 0) {
    return (
      <div className="min-h-[70vh] flex flex-col items-center justify-center text-center spacing">
        <h2 className="text-5xl font-bold shadow_hand mb-3">
          Bookmarks
          <Star className="inline-block" size={48} /> are Empty
        </h2>
        <p className="color_black">
          Empty? Wow. Even your ex had more tools😭. Add some! 😁😎
        </p>

        <Link href="/" className="mt-5">
          <Button className="rounded-none">Explore Tools</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="px-5 sm:px-12 py-14">
      <div className="flex gap-y-4 justify-center sm:justify-between flex-col sm:flex-row items-center mb-16 mt-4 spacing">
        <h1 className="text-5xl font-bold shadow_hand">
          My Bookmarks <Star className="inline-block" size={48} /> - {bookmarks.length}
        </h1>
        <Button
          variant="destructive"
          onClick={clearFilter}
          className="rounded-none"
        >
          Clear Bookmarks <Star className="inline-block" />
        </Button>
      </div>

      <div className="space-y-4">
        {bookmarks.map((tool) => (
          <div
            key={tool._id}
            id={tool._id}
            className="bg-white border border-dashed border-black shadow box_shadow p-4 relative group transition col-span-6"
          >
            <div className="flex items-center justify-center flex-wrap sm:justify-start sm:flex-nowrap gap-x-5 w-full">
              {tool?.image && (
                <Image
                  src={urlFor(tool.image).url()}
                  alt={tool.title}
                  width={250}
                  height={250}
                  className="border border-black"
                />
              )}

              <div className="w-full mt-5 sm:mt-0">
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl font-semibold shadow_hand">
                    {tool.title}
                  </h2>

                  <small className="text-xs text-green-700 font-semibold uppercase agile spacing">
                    {tool.price}
                  </small>
                </div>
                <p className="text-sm text-gray-600 neue_machina_regular pt-2.5 pb-5">
                  {tool.description.length > 180
                    ? `${tool.description.slice(0, 180)}... `
                    : tool.description}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-x-2 sm:gap-x-4 spacing">
                    <Link href={tool.tool_url} target="_blank">
                      <Button className="rounded-none">View Tool</Button>
                    </Link>
                    <Link href={`/tool/${tool.slug}`}>
                      <Button className="rounded-none">View Details</Button>
                    </Link>
                  </div>
                  <button
                    onClick={() => removeItem(tool._id)}
                    className="text-red-500 hover:text-red-700"
                  >
                    <Trash2 size={25} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bookmarks;
